import React from "react";

import "../css/MobileFilterPanel.css";
import Filter from "./filter/filter";
import classes from "../css/MobileFilterPanel.module.scss";

const STATIC_TITLE_DATA = {
  jewellery: "Jewellery",
  trending: "Trending Jewellery",
};

const MobileFilterPanel = (props) => {
  const {
    facetValues,
    selectedFilters,
    resetFilters,
    facetStatsValues,
    selectedRangeFilters,
    setSelectedRangeFilters,
    setSelectedFilters,
    showModal,
    setShowModal,
    searchQuery,
    selectedSorting,
    setSelectedSorting,
    totalProducts,
    loadRange,
    setLoadRange,
    categorySlug,
  } = props;
  const title = props.title || STATIC_TITLE_DATA[categorySlug];
  const defaultSortValue = window.rc.algoliasearch.defaultIndex;
  const mobileSortOptions = window.filterOption.algolia_sorting.filter(
    (element) => element.value !== defaultSortValue,
  );
  const mobileSortValue = selectedSorting || defaultSortValue;
  const isEmptySort =
    mobileSortValue && mobileSortValue.replace("products_list", "");
  const selectedSortMatch = window.filterOption.algolia_sorting.find(
    (element) => element.value === mobileSortValue,
  );
  const mobileSortLabel =
    isEmptySort && selectedSortMatch ? selectedSortMatch.name : "Sort By";
  const hideMobileTopPanel = totalProducts === 0;

  return (
    <>
      {!hideMobileTopPanel && (
        <div className={`${classes.mobile_sticky_panel} uk-hidden@l`}>
          <div className={`${classes.title_section} uk-width-expand@m`}>
            {title && <h2
              className={`${classes.title} uk-h2 uk-text-left uk-padding-remove`}
            >
              {title}
            </h2>}
            {totalProducts > 0 && (
              <p className={classes.total}>{totalProducts} Products</p>
            )}
          </div>
          {totalProducts > 0 && (
            <div className={classes.filter_sort_section}>
              <button
                className={classes.filter_btn}
                onClick={() => setShowModal(true)}
                type="button"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M10 6H3" stroke="black" strokeWidth="1.5" strokeLinejoin="round" />
                  <path d="M14 4V8" stroke="black" strokeWidth="1.5" strokeLinejoin="round" />
                  <path d="M21 6H14" stroke="black" strokeWidth="1.5" strokeLinejoin="round" />
                  <path d="M21 12H12" stroke="black" strokeWidth="1.5" strokeLinejoin="round" />
                  <path d="M8 10V14" stroke="black" strokeWidth="1.5" strokeLinejoin="round" />
                  <path d="M8 12H3" stroke="black" strokeWidth="1.5" strokeLinejoin="round" />
                  <path d="M12 18H3" stroke="black" strokeWidth="1.5" strokeLinejoin="round" />
                  <path d="M16 16V20" stroke="black" strokeWidth="1.5" strokeLinejoin="round" />
                  <path d="M21 18H16" stroke="black" strokeWidth="1.5" strokeLinejoin="round" />
                </svg>
                <small className="uk-text-left uk-width-1-1 uk-margin-remove">
                  Filter
                </small>
              </button>
              <div className={classes.sort_btn}>
                <span className={classes.sort_text}>{mobileSortLabel}</span>
                <select
                  className={classes.sort_select}
                  value={isEmptySort ? mobileSortValue : ""}
                  onChange={(event) => setSelectedSorting(event.target.value)}
                  aria-label="Sort products"
                >
                  <option value="" disabled>
                    Sort By
                  </option>
                  {mobileSortOptions.map((element) => (
                    <option key={element.value} value={element.value}>
                      {element.name}
                    </option>
                  ))}
                </select>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M2 7.5H22" stroke="black" strokeWidth="1.5" strokeLinejoin="round" />
                  <path d="M6 11.5H18" stroke="black" strokeWidth="1.5" strokeLinejoin="round" />
                  <path d="M9 15.5H15" stroke="black" strokeWidth="1.5" strokeLinejoin="round" />
                </svg>
              </div>
            </div>
          )}
        </div>
      )}
      {showModal && (
        <div className={classes.mobile_filter_panel}>
          <div className="uk-panel uk-padding-remove h-100 uk-position-relative">
            <div className={classes.header_section}>
              <h4 className={classes.title}>Filter</h4>
              <button
                className={classes.close_btn}
                type="button"
                onClick={() => setShowModal(false)}
              >
                <i className="icon-close"></i>
              </button>
            </div>
            <div className={`uk-width-1-1 h-100 ${classes.filter_panel}`}>
              <Filter
                facetValues={facetValues}
                selectedFilters={selectedFilters}
                resetFilters={resetFilters}
                facetStatsValues={facetStatsValues}
                selectedRangeFilters={selectedRangeFilters}
                setSelectedRangeFilters={setSelectedRangeFilters}
                setSelectedFilters={setSelectedFilters}
                setShowModal={setShowModal}
                searchQuery={searchQuery}
                loadRange={loadRange}
                setLoadRange={setLoadRange}
                isMobileFilterPanel
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default MobileFilterPanel;
